export default __webpack_public_path__ + "static/media/icon_finished.ebb9ec52.svg";